__turbopack_context__.v({
  "banner-img": "NewsLetters2-module__Wnq_ra__banner-img",
  "banner-main": "NewsLetters2-module__Wnq_ra__banner-main",
  "banner-sub": "NewsLetters2-module__Wnq_ra__banner-sub",
  "buttonBox": "NewsLetters2-module__Wnq_ra__buttonBox",
  "card-footer-text": "NewsLetters2-module__Wnq_ra__card-footer-text",
  "cardContainer": "NewsLetters2-module__Wnq_ra__cardContainer",
  "container": "NewsLetters2-module__Wnq_ra__container",
  "content": "NewsLetters2-module__Wnq_ra__content",
  "darkBG": "NewsLetters2-module__Wnq_ra__darkBG",
  "divider": "NewsLetters2-module__Wnq_ra__divider",
  "error-message": "NewsLetters2-module__Wnq_ra__error-message",
  "form-group": "NewsLetters2-module__Wnq_ra__form-group",
  "google-btn": "NewsLetters2-module__Wnq_ra__google-btn",
  "illustration": "NewsLetters2-module__Wnq_ra__illustration",
  "inputBox": "NewsLetters2-module__Wnq_ra__inputBox",
  "intro": "NewsLetters2-module__Wnq_ra__intro",
  "large-4": "NewsLetters2-module__Wnq_ra__large-4",
  "left": "NewsLetters2-module__Wnq_ra__left",
  "lightBG": "NewsLetters2-module__Wnq_ra__lightBG",
  "newLetterContainer": "NewsLetters2-module__Wnq_ra__newLetterContainer",
  "newsletter-bridge": "NewsLetters2-module__Wnq_ra__newsletter-bridge",
  "newsletter-card": "NewsLetters2-module__Wnq_ra__newsletter-card",
  "newsletter-columns": "NewsLetters2-module__Wnq_ra__newsletter-columns",
  "newsletter-grid": "NewsLetters2-module__Wnq_ra__newsletter-grid",
  "newsletter-header": "NewsLetters2-module__Wnq_ra__newsletter-header",
  "newsletter-promo": "NewsLetters2-module__Wnq_ra__newsletter-promo",
  "newsletter-promo__container": "NewsLetters2-module__Wnq_ra__newsletter-promo__container",
  "newsletter-section": "NewsLetters2-module__Wnq_ra__newsletter-section",
  "overlay": "NewsLetters2-module__Wnq_ra__overlay",
  "right": "NewsLetters2-module__Wnq_ra__right",
  "submit-btn": "NewsLetters2-module__Wnq_ra__submit-btn",
  "textCenter": "NewsLetters2-module__Wnq_ra__textCenter",
});
